import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"

export interface TestResolveData {
  TestEventID: number
  AlertResolved: boolean
  WatchResolved: boolean
  TimingAlertResolved: boolean
  ResultsAcknowledged: boolean
}
export default function ResultsResolveObservable(testsData: TestResolveData[], modifiedBy: string): Observable<string> {
  const params: string = JSON.stringify({ TestEventIDS: testsData, ModifiedBy: modifiedBy })
  return ObservableFromFetch<string>("FFOrderWatchResolve/Resolve", params)
}
